import { useState } from 'react';
import { Container, Title, Text, Stack, Card, Group, Badge, Button } from '@mantine/core';
import { PaymentQR } from '@/components/PaymentQR';
import { IconCreditCard, IconQrcode, IconBuilding } from '@tabler/icons-react';
import { PAYMENT_AMOUNT, getPaymentInfo, PAYMENT_UI } from '@/constants/paymentDetails';

export function PaymentPage() {
  const [amount, setAmount] = useState(PAYMENT_AMOUNT); // Государственная пошлина
  const [description, setDescription] = useState('Госпошлина за техосмотр ТС');
  const [paymentMethod, setPaymentMethod] = useState<'sbp' | 'bank'>('bank');
  
  const paymentInfo = getPaymentInfo(amount);

  return (
    <Container size="xl" py="xl">
      <Title order={1} mb="xl" ta="center">
        {PAYMENT_UI.title}
      </Title>
      
      <Text size="lg" mb="xl" ta="center" c="dimmed">
        {PAYMENT_UI.description}
      </Text>

      <Stack gap="xl">
        {/* Информация о заказе */}
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Title order={3} mb="md">Детали платежа</Title>
          <Stack gap="sm">
            <Group justify="space-between">
              <Text>{PAYMENT_UI.purposeLabel}</Text>
              <Badge color="green" size="lg">{amount} ₽</Badge>
            </Group>
            <Group justify="space-between">
              <Text c="dimmed">{paymentInfo.recipient}</Text>
              <Text size="sm" c="dimmed">ИНН: {paymentInfo.inn}</Text>
            </Group>
            <Text size="sm" c="dimmed">
              {paymentInfo.purpose}
            </Text>
          </Stack>
        </Card>

        {/* Способы оплаты */}
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Title order={3} mb="md">Способы оплаты</Title>
          <Group gap="md" mb="md">
            <Button
              variant={paymentMethod === 'sbp' ? 'filled' : 'outline'}
              color="blue"
              leftSection={<IconQrcode size={16} />}
              onClick={() => setPaymentMethod('sbp')}
            >
              СБП
            </Button>
            <Button
              variant={paymentMethod === 'bank' ? 'filled' : 'outline'}
              color="green"
              leftSection={<IconBuilding size={16} />}
              onClick={() => setPaymentMethod('bank')}
            >
              Банковский перевод
            </Button>
          </Group>
          
          <Text size="sm" c="dimmed">
            {paymentMethod === 'sbp' 
              ? 'СБП - самый быстрый способ оплаты. Отсканируйте QR-код в приложении банка. ⚠️ Для государственных платежей рекомендуется банковский перевод.'
              : 'Банковский перевод - рекомендуется для государственных платежей. Содержит все необходимые реквизиты (КПП, КБК, ОКТМО).'
            }
          </Text>
        </Card>

        {/* QR-код для оплаты */}
        <PaymentQR
          amount={amount}
          description={description}
          paymentMethod={paymentMethod}
          onAmountChange={setAmount}
          onDescriptionChange={setDescription}
          onPaymentMethodChange={setPaymentMethod}
          showForm={true}
        />

        {/* Дополнительная информация */}
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Title order={3} mb="md">Реквизиты для оплаты</Title>
          <Stack gap="sm">
            <Group justify="space-between">
              <Text fw={500}>{PAYMENT_UI.recipientLabel}:</Text>
              <Text>{paymentInfo.recipient}</Text>
            </Group>
            <Group justify="space-between">
              <Text fw={500}>{PAYMENT_UI.innLabel}:</Text>
              <Text>{paymentInfo.inn}</Text>
            </Group>
            <Group justify="space-between">
              <Text fw={500}>{PAYMENT_UI.kppLabel}:</Text>
              <Text>{paymentInfo.kpp}</Text>
            </Group>
            <Group justify="space-between">
              <Text fw={500}>{PAYMENT_UI.ogrnLabel}:</Text>
              <Text>{paymentInfo.ogrn}</Text>
            </Group>
            <Group justify="space-between">
              <Text fw={500}>{PAYMENT_UI.bankLabel}:</Text>
              <Text>{paymentInfo.bank.name}</Text>
            </Group>
            <Group justify="space-between">
              <Text fw={500}>{PAYMENT_UI.bikLabel}:</Text>
              <Text>{paymentInfo.bank.bik}</Text>
            </Group>
            <Group justify="space-between">
              <Text fw={500}>{PAYMENT_UI.treasuryAccountLabel}:</Text>
              <Text>{paymentInfo.bank.treasuryAccount}</Text>
            </Group>
            <Group justify="space-between">
              <Text fw={500}>{PAYMENT_UI.kbkLabel}:</Text>
              <Text>{paymentInfo.kbk}</Text>
            </Group>
            <Group justify="space-between">
              <Text fw={500}>{PAYMENT_UI.okatoLabel}:</Text>
              <Text>{paymentInfo.okato}</Text>
            </Group>
          </Stack>
        </Card>

        {/* Контактная информация */}
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Title order={3} mb="md">Контактная информация</Title>
          <Stack gap="sm">
            <Group>
              <IconCreditCard size={16} />
              <Text>По вопросам оплаты: +7 (926) 777-43-24</Text>
            </Group>
            <Group>
              <IconBuilding size={16} />
              <Text>Email: Auto-expert2025@mail.ru</Text>
            </Group>
          </Stack>
        </Card>
      </Stack>
    </Container>
  );
}
